import { createAction } from 'redux-actions'

const ns = 'importUsersAdmin/'

export const importUsers = createAction(`${ns}IMPORT_USERS`)
export const importUsersSuccess = createAction(`${ns}IMPORT_USERS_SUCCESS`)
export const importUsersFail = createAction(`${ns}IMPORT_USERS_FAIL`)
export const clearImportUsersResult = createAction(`${ns}CLEAR_RESULT`)
